import _object_spread from "@swc/helpers/src/_object_spread.mjs";
import _object_spread_props from "@swc/helpers/src/_object_spread_props.mjs";
import _object_without_properties from "@swc/helpers/src/_object_without_properties.mjs";
import _tagged_template_literal from "@swc/helpers/src/_tagged_template_literal.mjs";
import _to_consumable_array from "@swc/helpers/src/_to_consumable_array.mjs";
function _templateObject() {
    var data = _tagged_template_literal([
        ""
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}
import { jsx as _jsx } from "react/jsx-runtime";
import React, { useContext } from "react";
import { Box } from "@miro-site/core";
import styled from "styled-components";
var calculateGutterCompensation = function(gutter) {
    var toGutterCompensation = function(g) {
        if (g === null) {
            return null;
        }
        return -1 * (g / 2);
    };
    if (gutter === null) {
        return null;
    }
    if (!Array.isArray(gutter)) {
        return toGutterCompensation(gutter);
    } else {
        return gutter.map(toGutterCompensation);
    }
};
var calculateHalfGutterWidth = function(gutter) {
    var toHalfGutter = function(g) {
        if (g === null) {
            return null;
        }
        return g / 2;
    };
    if (gutter === null) {
        return null;
    }
    if (!Array.isArray(gutter)) {
        return toHalfGutter(gutter);
    } else {
        return gutter.map(toHalfGutter);
    }
};
var toWidth = function(columnCount, totalColumns) {
    if (columnCount === null || totalColumns === null) {
        return null;
    }
    return "".concat(Math.min(totalColumns, columnCount) / totalColumns * 100, "%");
};
var calculateColumnWidth = function(gridColumns, columns) {
    if (gridColumns === null || columns === null) {
        return null;
    }
    if (!Array.isArray(gridColumns) && !Array.isArray(columns)) {
        return toWidth(columns, gridColumns);
    }
    var gridColumnsArray = Array.isArray(gridColumns) ? gridColumns : [
        gridColumns
    ];
    var columnsArray = Array.isArray(columns) ? columns : [
        columns
    ];
    return _to_consumable_array(Array(Math.max(gridColumnsArray.length, columnsArray.length))).map(function(v, i) {
        var _$columns = typeof columnsArray[i] === "undefined" ? columnsArray[columnsArray.length - 1] : columnsArray[i];
        var _$gridColumns = typeof gridColumnsArray[i] === "undefined" ? gridColumnsArray[gridColumnsArray.length - 1] : gridColumnsArray[i];
        return toWidth(_$columns, _$gridColumns);
    });
};
var GridContext = /*#__PURE__*/ React.createContext({
    columns: null,
    gutter: null
});
var ALIGN_MAP = {
    top: "flex-start",
    bottom: "flex-end",
    stretch: "stretch",
    center: "center"
};
var Row = styled(Box).attrs(function(param) {
    var $gutterCompensation = param.$gutterCompensation, _align = param.align, align = _align === void 0 ? "top" : _align, _as = param.as, as = _as === void 0 ? "div" : _as;
    return {
        as: as,
        $mx: $gutterCompensation,
        $styles: {
            display: "flex",
            flex: "0 1 auto",
            flexDirection: "row",
            flexWrap: "wrap",
            alignItems: ALIGN_MAP[align]
        }
    };
}).withConfig({
    componentId: "sc-9282d9b1-0"
})(_templateObject());
var Column = function(props) {
    var columns = props.columns, children = props.children, restProps = _object_without_properties(props, [
        "columns",
        "children"
    ]);
    var gridSettings = useContext(GridContext);
    var halfGutterWidth = calculateHalfGutterWidth(gridSettings.gutter);
    var width = calculateColumnWidth(gridSettings.columns, columns || gridSettings.columns);
    return /*#__PURE__*/ _jsx(Box, _object_spread_props(_object_spread({
        $px: halfGutterWidth,
        $styles: {
            flex: "0 0 auto",
            flexBasis: width,
            maxWidth: width
        }
    }, restProps), {
        children: children
    }));
};
var Grid = function(props) {
    var children = props.children, columns = props.columns, gutter = props.gutter, restProps = _object_without_properties(props, [
        "children",
        "columns",
        "gutter"
    ]);
    var gutterCompensation = calculateGutterCompensation(gutter);
    return /*#__PURE__*/ _jsx(GridContext.Provider, {
        value: {
            columns: columns,
            gutter: gutter
        },
        children: /*#__PURE__*/ _jsx(Row, _object_spread_props(_object_spread({
            $gutterCompensation: gutterCompensation
        }, restProps), {
            children: children
        }))
    });
};
export default Object.assign(Grid, {
    Column: Column
});
